 
import http from "@/http/service"
 
export default function DeletarPromocao(idPromocao=0){

    return http.delete(`/parceiro/promocoes/${idPromocao}`)

}